import { FormModel } from "components/Form";
import { Validators } from "utils/validators";

export const NewBookingSendEmailFormComponent = (strings: any): FormModel[] => {
    return [
        {
            label: strings.beo_to_email_text,
            value: '',
            size: 'medium',
            autoFocus: false,
            type: 'text',
            typeValue: 'text',
            multiline: true,
            minRows: 1,
            maxRows: 3,
            variant: 'outlined',
            placeholder: '',
            field: 'to',
            validators: [],
            responsive: { xs: 12 },
            required: false,
            disabled: true,
        },
        {
            label: strings.beo_cc_email_text,
            value: '',
            size: 'medium',
            autoFocus: false,
            type: 'text',
            typeValue: 'text',
            variant: 'outlined',
            placeholder: '',
            field: 'cc',
            validators: [{ check: Validators.validateEmailList }],
            responsive: { xs: 12 },
            required: false,
            multiline: true,
            minRows: 1,
            maxRows: 7,
        },
        {
            label: strings.beo_bcc_email_text,
            value: '',
            size: 'medium',
            autoFocus: false,
            type: 'text',
            typeValue: 'text',
            variant: 'outlined',
            placeholder: '',
            field: 'bcc',
            validators: [{ check: Validators.validateEmailList }],
            responsive: { xs: 12 },
            required: false,
            multiline: true,
            minRows: 1,
            maxRows: 7,
        },
    ];
};
